import { useEffect, useState } from 'react'

export const loadState = (key: string): any => {
  try {
    const serializedState = localStorage.getItem('state_' + key)
    if (serializedState == null) {
      return undefined
    }
    return (serializedState)
  } catch (error) {
    console.error(error)
    return undefined
  }
}

export const saveState = (key: string, state: any): void => {
  try {
    const serializedState = (state)
    localStorage.setItem('state_' + key, serializedState)
  } catch (error) {
    console.error(error)
  }
}

export const removeState = (key: string): void => {
  try {
    localStorage.removeItem('state_' + key)
  } catch (error) {
    console.error(error)
  }
}

export function useLocalStorage<T> (key: string): [T | undefined, (value: T) => void, boolean]
export function useLocalStorage<T> (key: string, initialValue: T): [T, (value: T) => void, boolean]
export function useLocalStorage<T> (key: string, initialValue?: T): [T | undefined, (value: T) => void, boolean] {
  // State to store our value
  const [loaded, setLoaded] = useState<boolean>(false)
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState<T | undefined>(initialValue)

  useEffect(() => {
    try {
      // Get from local storage by key
      const item = window.localStorage.getItem(key)
      // Parse stored json or if none return initialValue
      if (item !== null && item !== undefined) {
        const value = JSON.parse(item)
        setStoredValue(value)
      }
      setLoaded(true)
    } catch (error) {
    }
  }, [])

  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = (value: T): void => {
    try {
      // Allow value to be a function so we have same API as useState
      if (value !== undefined) {
        const valueToStore =
          value instanceof Function ? value(storedValue) : value
        // Save state
        setStoredValue(valueToStore)
        // Save to local storage
        window.localStorage.setItem(key, JSON.stringify(valueToStore))
      } else {
        setStoredValue(undefined)
        window.localStorage.removeItem(key)
      }
    } catch (error) {
      // A more advanced implementation would handle the error case
    }
  }

  return [storedValue, setValue, loaded]
}

export default useLocalStorage
